import { Tabs } from "antd";
import {
  Link2,
  Bell,
  Globe,
  Clock,
  Calendar,
  ArrowLeft,
} from "lucide-react";
import Availability from "./Availability";
import MeetingTypes from "./MeetingTypes";
import NotificationSettings from "./NotificationSettings";
import Integrations from "./Integrations";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import BookingLinkPage from "./BookingLinkPage";

const AvailabilityFeature = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("1");
  const tab = searchParams.get("tab");

  useEffect(() => {
    if (tab) {
      setActiveTab(tab);
    } else {
      setActiveTab("1");
    }
  }, [tab]);

  return (
    <div className="p-20 tw-font-inter">
      <div className="tw-mb-6 tw-flex tw-items-center tw-gap-4">
        <div
          className="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-xl tw-p-2 tw-bg-slate-100 hover:tw-bg-slate-200/60 tw-text-slate-600 tw-transition-colors"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={18} />
        </div>
        <div className="tw-flex tw-flex-col tw-justify-center tw-gap-0.5">
          <h1 className="tw-text-xl tw-font-bold tw-mb-0 tw-text-slate-800 tw-font-inter">
            Calendar & Availability Settings
          </h1>
          <p className="tw-text-xs tw-mb-0 tw-text-slate-500 tw-font-medium">
            Set your availability, manage meeting types, and share your booking
            link.
          </p>
        </div>
      </div>
      <Tabs
        activeKey={activeTab}
        className="availability-tabs tw-font-inter"
        onChange={(key) => {
          setActiveTab(key);
          navigate(`${location.pathname}?tab=${key}`);
        }}
        items={[
          {
            key: "1",
            label: (
              <span className="tw-flex tw-items-center tw-gap-2">
                <Clock size={16} /> Availability
              </span>
            ),
            children: <Availability />,
          },
          {
            key: "2",
            label: (
              <span className="tw-flex tw-items-center tw-gap-2">
                <Calendar size={16} /> Meetings
              </span>
            ),
            children: <MeetingTypes />,
          },
          {
            key: "3",
            label: (
              <span className="tw-flex tw-items-center tw-gap-2">
                <Bell size={16} /> Notifications
              </span>
            ),
            children: <NotificationSettings />,
          },
          {
            key: "4",
            label: (
              <span className="tw-flex tw-items-center tw-gap-2">
                <Globe size={16} /> Integrations
              </span>
            ),
            children: <Integrations />,
          },
          {
            key: "5",
            label: (
              <span className="tw-flex tw-items-center tw-gap-2">
                <Link2 size={16} /> Link
              </span>
            ),
            children: <BookingLinkPage />,
          },
        ]}
      />
    </div>
  );
};

export default AvailabilityFeature;
